import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getCookie } from 'src/app/feature/login/utils/cookie-utils';

@Injectable({
  providedIn: 'root'
})
export class LoginTypeGuard implements CanActivate {
  constructor(private store: Store, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = getCookie('token');
    if (token !== undefined && next.routeConfig.path === 'internal') {
      this.router.navigateByUrl('/');
      return false;
    } else if (token === undefined && next.routeConfig.path === 'external') {
      this.router.navigateByUrl('/');
      return false;
    } else {
      return true;
    }
  }

}
